import { render, staticRenderFns } from "./Watchexclusionlists.vue?vue&type=template&id=f8081884&"
import script from "./Watchexclusionlists.vue?vue&type=script&lang=js&"
export * from "./Watchexclusionlists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports